<div class="legends">
  <h6 class="mb-1">{{ 'page.qualifications.legends' | translate }}</h6>
  <ul class="list-group list-group-flush">
    <li class="list-group-item text-muted border-0 pb-0 ps-0">
      <img
        class="me-2"
        src="../../../assets/img/svg-icons/Icon_Qualification-Confirmation-01.svg"
      />
      {{ 'page.qualifications.legends_confirmed' | translate }}
    </li>
    <li class="list-group-item text-muted border-0 pb-0 ps-0">
      <img
        class="me-2"
        src="../../../assets/img/svg-icons/Icon_Qualification-Confirmation-02.svg"
        alt=""
      />
      {{ 'page.qualifications.legends_not_confirmed' | translate }}
    </li>
    <li class="list-group-item text-muted border-0 pb-0 ps-0">
      <img
        class="me-2"
        src="../../assets/img/svg-icons/qualification_status_valid.svg"
      />
      {{ 'page.qualifications.legends_valid' | translate }}
    </li>
    <li class="list-group-item text-muted border-0 pb-0 ps-0">
      <img
        class="me-2"
        src="../../assets/img/svg-icons/qualification_status_expiresSoon.svg"
      />
      {{ 'page.qualifications.legends_expiresSoon' | translate }}
    </li>
    <li class="list-group-item text-muted border-0 pb-0 ps-0">
      <img
        class="me-2"
        src="../../assets/img/svg-icons/qualification_status_expired.svg"
      />
      {{ 'page.qualifications.legends_expired' | translate }}
    </li>
  </ul>
</div>
